<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div>
                    <span>자동충전 설정을</span>
                    <span>해지하시겠습니까?</span>
                </div>
            </div>
            <div class="button-wrap">
              <button @click="btnEvent('N')" class="button-bg-gray">아니요</button>
              <button @click="btnEvent('Y')" class="button-bg-yellow">예</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChargingPopup',
    data() {
      return {
      }
    },
    methods : {
      btnEvent(item) {
        this.$emit('emitPopValue', item)
      }
    }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/cards/chargingPopup.scss';
</style>